import ActivityListValidator from '../activity-list/activity-list.validator';
import FileService from '../../services/file-service';
import FormatService from '../../services/format-service';
import FormService from '../../services/form-service';
import { FILE_EXTENSION_LIST_IMAGE } from '../../constants/system/file-extensions';
import { CONTACT_TYPE_COMPANY, CONTACT_TYPE_PERSON } from '../../constants/entity/contact-types';
import ACCOUNT_USER_TYPE_GROUP_EXTERNAL from '../../constants/entity/account-user-type-groups';

const DealValidator: Validator = (values: FormValues): ValidationErrors => {
  const errors: ValidationErrors = {};

  const formKeyNew: string = FormService.getIndexedFormFieldKey(FormService.FORM_KEY_NEW);

  const dealCommonRequiredFields: string[] = [
    'name',
    'status',
  ];

  const contactPersonRequiredFields: string[] = [
    'firstName',
    'lastName',
    'type',
  ];

  const contactCompanyRequiredFields: string[] = [
    'type',
    'name',
  ];

  const assetRequiredFields: string[] = [
    'portfolioId',
  ];

  const dealAllocationItemRequiredFields: string[] = [
    'portfolioId',
  ];

  const dealCapitalizationItemRequiredFields: string[] = [
    'name',
  ];

  const dealTermGroupRequiredFields: string[] = [
    'name',
  ];

  const dealTermRequiredFields: string[] = [
    'name',
    'content',
  ];

  const dealValuationFileGroupRequiredFields: string[] = [
    'name',
  ];

  const dealValuationFileRequiredFields: string[] = [
    'name',
  ];

  const dealTaskGroupRequiredFields: string[] = [
    'name',
  ];

  const dealTaskRequiredFields: string[] = [
    'name',
  ];

  const dealParticipantRequiredFields: string[] = [
    'groupId',
    'contactId',
  ];

  const dealFileGroupRequiredFields: string[] = [
    'name',
  ];

  const dealFileRequiredFields: string[] = [
    'name',
  ];

  const dealScheduleRequiredFields: string[] = [
    'name',
  ];

  const dealScheduleTaskRequiredFields: string[] = [
    'id',
    'name',
    'startedAt',
    'duration',
  ];

  const dealScheduleTaskLinkRequiredFields: string[] = [
    'id',
    'sourceId',
    'targetId',
    'type',
  ];

  const dealParticipantUserRequiredFields: string[] = [
    'email',
    'role',
    'accountUserType',
  ];

  if (values.dealData) {
    if (!errors.dealData) {
      errors.dealData = {};
    }

    if (values.dealData.dealCommonData) {
      if (!errors.dealData.dealCommonData) {
        errors.dealData.dealCommonData = {};
      }

      dealCommonRequiredFields.forEach((field: string): void => {
        if ((!values.dealData.dealCommonData[field] || !values.dealData.dealCommonData[field].toString().trim())
          && values.dealData.dealCommonData[field] !== null) {
          errors.dealData.dealCommonData[field] = 'Required';
        }
      });

      if (!errors.dealData.dealCommonData.asset) {
        errors.dealData.dealCommonData.asset = {};
      }

      assetRequiredFields.forEach((field: string): void => {
        if (!values.dealData.dealCommonData.asset || (
          values.dealData.dealCommonData.asset && (!values.dealData.dealCommonData.asset[field]
            || !values.dealData.dealCommonData.asset[field].toString().trim())
          && values.dealData.dealCommonData.asset[field] !== null
        )) {
          errors.dealData.dealCommonData.asset[field] = 'Required';
        }
      });

      if (values.dealData.dealCommonData.asset && Object.keys(values.dealData.dealCommonData.asset).length) {
        if (!values.dealData.dealCommonData.asset.address && values.dealData.dealCommonData.asset.streetAddress) {
          errors.dealData.dealCommonData.asset.streetAddress = 'Incorrect address value';
        }

        if (
          values.dealData.dealCommonData.asset.mainPhoto
          && !FileService.checkFileExtension(values.dealData.dealCommonData.asset.mainPhoto, FILE_EXTENSION_LIST_IMAGE)
        ) {
          errors.dealData.dealCommonData.asset.mainPhoto = 'Incorrect file type';
        }
      }

      if (errors.dealData.dealCommonData.asset && !Object.keys(errors.dealData.dealCommonData.asset).length) {
        delete errors.dealData.dealCommonData.asset;
      }

      if (values.dealData.dealCommonData.sponsor && Object.keys(values.dealData.dealCommonData.sponsor).length) {
        if (!errors.dealData.dealCommonData.sponsor) {
          errors.dealData.dealCommonData.sponsor = {};
        }

        const dealSponsor: ValidationEntityInput = {
          ...values.dealData.dealCommonData.sponsor,
        };
        const dealSponsorRequiredFields: string[] = dealSponsor.type === CONTACT_TYPE_COMPANY
          ? contactCompanyRequiredFields : contactPersonRequiredFields;

        dealSponsorRequiredFields.forEach((field: string): void => {
          if (!dealSponsor[field] || !dealSponsor[field].toString().trim()) {
            errors.dealData.dealCommonData.sponsor[field] = 'Required';
          }
        });

        if (dealSponsor.type !== CONTACT_TYPE_PERSON && dealSponsor.type !== CONTACT_TYPE_COMPANY) {
          errors.dealData.dealCommonData.sponsor.type = 'Incorrect contact type';
        }

        if (dealSponsor.email && !FormatService.isValidEmail(dealSponsor.email)) {
          errors.dealData.dealCommonData.sponsor.email = 'Invalid email address';
        }

        if (errors.dealData.dealCommonData.sponsor && !Object.keys(errors.dealData.dealCommonData.sponsor).length) {
          delete errors.dealData.dealCommonData.sponsor;
        }
      }

      if (values.dealData.dealCommonData.broker && Object.keys(values.dealData.dealCommonData.broker).length) {
        if (!errors.dealData.dealCommonData.broker) {
          errors.dealData.dealCommonData.broker = {};
        }

        const dealBroker: ValidationEntityInput = {
          ...values.dealData.dealCommonData.broker,
        };
        const dealBrokerRequiredFields: string[] = dealBroker.type === CONTACT_TYPE_COMPANY
          ? contactCompanyRequiredFields : contactPersonRequiredFields;

        dealBrokerRequiredFields.forEach((field: string): void => {
          if (!dealBroker[field] || !dealBroker[field].toString().trim()) {
            errors.dealData.dealCommonData.broker[field] = 'Required';
          }
        });

        if (dealBroker.type !== CONTACT_TYPE_PERSON && dealBroker.type !== CONTACT_TYPE_COMPANY) {
          errors.dealData.dealCommonData.broker.type = 'Incorrect contact type';
        }

        if (dealBroker.email && !FormatService.isValidEmail(dealBroker.email)) {
          errors.dealData.dealCommonData.broker.email = 'Invalid email address';
        }

        if (errors.dealData.dealCommonData.broker && !Object.keys(errors.dealData.dealCommonData.broker).length) {
          delete errors.dealData.dealCommonData.broker;
        }
      }

      if (values.dealData.dealCommonData.lender && Object.keys(values.dealData.dealCommonData.lender).length) {
        if (!errors.dealData.dealCommonData.lender) {
          errors.dealData.dealCommonData.lender = {};
        }

        const dealLender: ValidationEntityInput = {
          ...values.dealData.dealCommonData.lender,
        };
        const dealLenderRequiredFields: string[] = dealLender.type === CONTACT_TYPE_COMPANY
          ? contactCompanyRequiredFields : contactPersonRequiredFields;

        dealLenderRequiredFields.forEach((field: string): void => {
          if (!dealLender[field] || !dealLender[field].toString().trim()) {
            errors.dealData.dealCommonData.lender[field] = 'Required';
          }
        });

        if (dealLender.type !== CONTACT_TYPE_PERSON && dealLender.type !== CONTACT_TYPE_COMPANY) {
          errors.dealData.dealCommonData.lender.type = 'Incorrect contact type';
        }

        if (dealLender.email && !FormatService.isValidEmail(dealLender.email)) {
          errors.dealData.dealCommonData.lender.email = 'Invalid email address';
        }

        if (errors.dealData.dealCommonData.lender && !Object.keys(errors.dealData.dealCommonData.lender).length) {
          delete errors.dealData.dealCommonData.lender;
        }
      }

      if (values.dealData.dealCommonData.allocationItems
        && Object.keys(values.dealData.dealCommonData.allocationItems).length) {
        if (!errors.dealData.dealCommonData.allocationItems) {
          errors.dealData.dealCommonData.allocationItems = {};
        }

        const portfolioIds: number[] = [];

        Object.keys(values.dealData.dealCommonData.allocationItems).forEach((dealAllocationItemIndex: string): void => {
          const dealAllocationItem: ValidationEntityInput = {
            ...values.dealData.dealCommonData.allocationItems[dealAllocationItemIndex],
          };

          if (dealAllocationItem && Object.keys(dealAllocationItem).length) {
            if (!errors.dealData.dealCommonData.allocationItems[dealAllocationItemIndex]) {
              errors.dealData.dealCommonData.allocationItems[dealAllocationItemIndex] = {};
            }

            dealAllocationItemRequiredFields.forEach((field: string): void => {
              if (!dealAllocationItem[field] || !dealAllocationItem[field].toString().trim()) {
                errors.dealData.dealCommonData.allocationItems[dealAllocationItemIndex][field] = 'Required';
              }
            });

            if (portfolioIds.includes(dealAllocationItem.portfolioId)) {
              errors.dealData.dealCommonData.allocationItems[dealAllocationItemIndex].portfolioId = (
                'An item with this portfolio already exists'
              );
            } else {
              portfolioIds.push(dealAllocationItem.portfolioId);
            }

            if (errors.dealData.dealCommonData.allocationItems[dealAllocationItemIndex]
              && !Object.keys(errors.dealData.dealCommonData.allocationItems[dealAllocationItemIndex]).length) {
              delete errors.dealData.dealCommonData.allocationItems[dealAllocationItemIndex];
            }
          }
        });

        if (errors.dealData.dealCommonData.allocationItems
          && !Object.keys(errors.dealData.dealCommonData.allocationItems).length) {
          delete errors.dealData.dealCommonData.allocationItems;
        }
      }

      if (errors.dealData.dealCommonData && !Object.keys(errors.dealData.dealCommonData).length) {
        delete errors.dealData.dealCommonData;
      }
    }

    if (values.dealData.dealPhotosData && Object.keys(values.dealData.dealPhotosData).length) {
      if (!errors.dealData.dealPhotosData) {
        errors.dealData.dealPhotosData = {};
      }

      Object.keys(values.dealData.dealPhotosData).forEach((dealPhotoIndex: string): void => {
        if (
          values.dealData.dealPhotosData[dealPhotoIndex].file && (
            !FileService.checkFileExtension(
              values.dealData.dealPhotosData[dealPhotoIndex].file,
              FILE_EXTENSION_LIST_IMAGE,
            )
          )
        ) {
          if (!errors.dealData.dealPhotosData[dealPhotoIndex]) {
            errors.dealData.dealPhotosData[dealPhotoIndex] = {};
          }

          errors.dealData.dealPhotosData[dealPhotoIndex].file = 'Incorrect file type';
        }
      });

      if (errors.dealData.dealPhotosData && !Object.keys(errors.dealData.dealPhotosData).length) {
        delete errors.dealData.dealPhotosData;
      }
    }

    if (values.dealData.dealBuildingDetailsData && values.dealData.dealBuildingDetailsData.assetUseBreakdown) {
      if (!errors.dealData.dealBuildingDetailsData) {
        errors.dealData.dealBuildingDetailsData = {
          assetUseBreakdown: {},
        };
      }

      Object.keys(values.dealData.dealBuildingDetailsData.assetUseBreakdown).forEach((valueIndex: string): void => {
        const dealAssetUseBreakdownData: ValidationEntityInput = {
          ...values.dealData.dealBuildingDetailsData.assetUseBreakdown[valueIndex],
        };

        if (dealAssetUseBreakdownData && Object.keys(dealAssetUseBreakdownData).length) {
          if (!errors.dealData.dealBuildingDetailsData.assetUseBreakdown[valueIndex]) {
            errors.dealData.dealBuildingDetailsData.assetUseBreakdown[valueIndex] = {};
          }

          if (!dealAssetUseBreakdownData.assetTypeId) {
            errors.dealData.dealBuildingDetailsData.assetUseBreakdown[valueIndex].assetTypeId = 'Required';
          }

          if (errors.dealData.dealBuildingDetailsData.assetUseBreakdown[valueIndex]
            && !Object.keys(errors.dealData.dealBuildingDetailsData.assetUseBreakdown[valueIndex]).length) {
            delete errors.dealData.dealBuildingDetailsData.assetUseBreakdown[valueIndex];
          }
        }
      });

      if (errors.dealData.dealBuildingDetailsData && (
        !Object.keys(errors.dealData.dealBuildingDetailsData).length
        || !Object.keys(errors.dealData.dealBuildingDetailsData.assetUseBreakdown).length
      )) {
        delete errors.dealData.dealBuildingDetailsData;
      }
    }

    if (values.dealData.dealCapitalizationData) {
      if (!errors.dealData.dealCapitalizationData) {
        errors.dealData.dealCapitalizationData = {
          sources: {},
          uses: {},
        };
      }

      if (values.dealData.dealCapitalizationData.sources
        && Object.keys(values.dealData.dealCapitalizationData.sources).length) {
        Object.keys(values.dealData.dealCapitalizationData.sources).forEach((valueGroupIndex: string): void => {
          const dealCapitalizationSourceGroupData: ValidationEntityInput = {
            ...values.dealData.dealCapitalizationData.sources[valueGroupIndex],
          };

          if (!dealCapitalizationSourceGroupData) {
            return;
          }

          if (!errors.dealData.dealCapitalizationData.sources[valueGroupIndex]) {
            errors.dealData.dealCapitalizationData.sources[valueGroupIndex] = {
              items: {},
            };
          }

          if (dealCapitalizationSourceGroupData.items) {
            Object.keys(dealCapitalizationSourceGroupData.items).forEach((valueIndex: string): void => {
              const dealCapitalizationSourceItemData: ValidationEntityInput = {
                ...dealCapitalizationSourceGroupData.items[valueIndex],
              };

              if (!dealCapitalizationSourceItemData || (dealCapitalizationSourceItemData
                && !Object.keys(dealCapitalizationSourceItemData).length)) {
                return;
              }

              if (!errors.dealData.dealCapitalizationData.sources[valueGroupIndex].items[valueIndex]) {
                errors.dealData.dealCapitalizationData.sources[valueGroupIndex].items[valueIndex] = {};
              }

              dealCapitalizationItemRequiredFields.forEach((field: string): void => {
                if ((!dealCapitalizationSourceItemData[field]
                    || !dealCapitalizationSourceItemData[field].toString().trim())
                  && dealCapitalizationSourceItemData[field] !== null) {
                  errors.dealData.dealCapitalizationData.sources[valueGroupIndex].items[valueIndex][field] = 'Required';
                }
              });

              if ((!dealCapitalizationSourceItemData.type || !dealCapitalizationSourceItemData.type.toString().trim())
                && dealCapitalizationSourceGroupData.isSystem) {
                errors.dealData.dealCapitalizationData.sources[valueGroupIndex].items[valueIndex].type = 'Required';
              }

              if (errors.dealData.dealCapitalizationData.sources[valueGroupIndex].items[valueIndex] && (
                !Object.keys(errors.dealData.dealCapitalizationData.sources[valueGroupIndex].items[valueIndex]).length
                || dealCapitalizationSourceItemData.name === null
              )) {
                delete errors.dealData.dealCapitalizationData.sources[valueGroupIndex].items[valueIndex];
              }
            });
          }

          if (errors.dealData.dealCapitalizationData.sources[valueGroupIndex] && (
            !Object.keys(errors.dealData.dealCapitalizationData.sources[valueGroupIndex]).length
            || !Object.keys(errors.dealData.dealCapitalizationData.sources[valueGroupIndex].items).length
          )) {
            delete errors.dealData.dealCapitalizationData.sources[valueGroupIndex];
          }
        });
      }

      if (values.dealData.dealCapitalizationData.uses
        && Object.keys(values.dealData.dealCapitalizationData.uses).length) {
        Object.keys(values.dealData.dealCapitalizationData.uses).forEach((valueGroupIndex: string): void => {
          const dealCapitalizationUseGroupData: ValidationEntityInput = {
            ...values.dealData.dealCapitalizationData.uses[valueGroupIndex],
          };

          if (!dealCapitalizationUseGroupData) {
            return;
          }

          if (!errors.dealData.dealCapitalizationData.uses[valueGroupIndex]) {
            errors.dealData.dealCapitalizationData.uses[valueGroupIndex] = {
              items: {},
            };
          }

          if (dealCapitalizationUseGroupData.items) {
            Object.keys(dealCapitalizationUseGroupData.items).forEach((valueIndex: string): void => {
              const dealCapitalizationUseItemData: ValidationEntityInput = {
                ...dealCapitalizationUseGroupData.items[valueIndex],
              };

              if (!dealCapitalizationUseItemData || (dealCapitalizationUseItemData
                && !Object.keys(dealCapitalizationUseItemData).length)) {
                return;
              }

              if (!errors.dealData.dealCapitalizationData.uses[valueGroupIndex].items[valueIndex]) {
                errors.dealData.dealCapitalizationData.uses[valueGroupIndex].items[valueIndex] = {};
              }

              dealCapitalizationItemRequiredFields.forEach((field: string): void => {
                if ((!dealCapitalizationUseItemData[field]
                    || !dealCapitalizationUseItemData[field].toString().trim())
                  && dealCapitalizationUseItemData[field] !== null) {
                  errors.dealData.dealCapitalizationData.uses[valueGroupIndex].items[valueIndex][field] = 'Required';
                }
              });

              if ((!dealCapitalizationUseItemData.type || !dealCapitalizationUseItemData.type.toString().trim())
                && dealCapitalizationUseItemData.isSystem) {
                errors.dealData.dealCapitalizationData.uses[valueGroupIndex].items[valueIndex].type = 'Required';
              }

              if (errors.dealData.dealCapitalizationData.uses[valueGroupIndex].items[valueIndex] && (
                !Object.keys(errors.dealData.dealCapitalizationData.uses[valueGroupIndex].items[valueIndex]).length
                || dealCapitalizationUseItemData.name === null
              )) {
                delete errors.dealData.dealCapitalizationData.uses[valueGroupIndex].items[valueIndex];
              }
            });
          }

          if (errors.dealData.dealCapitalizationData.uses[valueGroupIndex] && (
            !Object.keys(errors.dealData.dealCapitalizationData.uses[valueGroupIndex]).length
            || !Object.keys(errors.dealData.dealCapitalizationData.uses[valueGroupIndex].items).length
          )) {
            delete errors.dealData.dealCapitalizationData.uses[valueGroupIndex];
          }
        });
      }

      if (errors.dealData.dealCapitalizationData && (
        !errors.dealData.dealCapitalizationData.sources
        || !Object.keys(errors.dealData.dealCapitalizationData.sources).length
      )) {
        delete errors.dealData.dealCapitalizationData.sources;
      }

      if (errors.dealData.dealCapitalizationData && (
        !errors.dealData.dealCapitalizationData.uses
        || !Object.keys(errors.dealData.dealCapitalizationData.uses).length
      )) {
        delete errors.dealData.dealCapitalizationData.uses;
      }

      if (errors.dealData.dealCapitalizationData && !errors.dealData.dealCapitalizationData.sources
        && !errors.dealData.dealCapitalizationData.uses) {
        delete errors.dealData.dealCapitalizationData;
      }
    }

    if (values.dealData.dealEquityOrganizationChartData && values.dealData.dealEquityOrganizationChartData.file
      && values.dealData.dealEquityOrganizationChartData.file.name) {
      const isDealEquityOrganizationChartCorrect: boolean = FileService.checkFileExtension(
        values.dealData.dealEquityOrganizationChartData.file,
        FILE_EXTENSION_LIST_IMAGE,
      );

      if (!isDealEquityOrganizationChartCorrect) {
        if (!errors.dealData.dealEquityOrganizationChartData) {
          errors.dealData.dealEquityOrganizationChartData = {};
        }

        errors.dealData.dealEquityOrganizationChartData.file = 'Incorrect file type';
      }
    }

    if (values.dealData.dealTermsData) {
      if (!errors.dealData.dealTermsData) {
        errors.dealData.dealTermsData = {};
      }

      Object.keys(values.dealData.dealTermsData).forEach((valueGroupIndex: string): void => {
        if (!errors.dealData.dealTermsData[valueGroupIndex]) {
          errors.dealData.dealTermsData[valueGroupIndex] = {
            terms: {},
          };
        }

        if (values.dealData.dealTermsData[valueGroupIndex]) {
          dealTermGroupRequiredFields.forEach((field: string): void => {
            if ((values.dealData.dealTermsData[valueGroupIndex]
                && !values.dealData.dealTermsData[valueGroupIndex][field])
              || (values.dealData.dealTermsData[valueGroupIndex]
                && !values.dealData.dealTermsData[valueGroupIndex][field].toString().trim())) {
              errors.dealData.dealTermsData[valueGroupIndex][field] = 'Required';
            }
          });

          if (values.dealData.dealTermsData[valueGroupIndex].terms
            && Object.keys(values.dealData.dealTermsData[valueGroupIndex].terms).length) {
            Object.keys(values.dealData.dealTermsData[valueGroupIndex].terms).forEach((valueIndex: string): void => {
              const dealTermId: number = FormatService.parseInt(
                FormService.extractIndexedFormFieldKey(valueIndex) as string,
              );
              const dealTermData: ValidationEntityInput = {
                ...values.dealData.dealTermsData[valueGroupIndex].terms[valueIndex],
              };

              if (!dealTermData) {
                return;
              }

              if (!errors.dealData.dealTermsData[valueGroupIndex].terms[valueIndex]) {
                errors.dealData.dealTermsData[valueGroupIndex].terms[valueIndex] = {};
              }

              dealTermRequiredFields.forEach((field: string): void => {
                if (!dealTermData[field] || !dealTermData[field].toString().trim()) {
                  errors.dealData.dealTermsData[valueGroupIndex].terms[valueIndex][field] = 'Required';
                }
              });

              if (errors.dealData.dealTermsData[valueGroupIndex].terms[valueIndex] && (
                !Object.keys(errors.dealData.dealTermsData[valueGroupIndex].terms[valueIndex]).length
                || ((valueIndex === formKeyNew || dealTermId < 0) && (dealTermData.name === null
                  || dealTermData.content === null))
              )) {
                delete errors.dealData.dealTermsData[valueGroupIndex].terms[valueIndex];
              }
            });
          }
        }

        if (!Object.keys(errors.dealData.dealTermsData[valueGroupIndex].terms).length) {
          delete errors.dealData.dealTermsData[valueGroupIndex].terms;
        }

        if (errors.dealData.dealTermsData[valueGroupIndex] && (
          !Object.keys(errors.dealData.dealTermsData[valueGroupIndex]).length
          || (valueGroupIndex === formKeyNew && values.dealData.dealTermsData[valueGroupIndex].name === null
            && (!errors.dealData.dealTermsData[valueGroupIndex].terms
              || !Object.keys(errors.dealData.dealTermsData[valueGroupIndex].terms).length))
        )) {
          delete errors.dealData.dealTermsData[valueGroupIndex];
        }
      });

      if (errors.dealData.dealTermsData && !Object.keys(errors.dealData.dealTermsData).length) {
        delete errors.dealData.dealTermsData;
      }
    }

    if (values.dealData.dealValuationFilesData) {
      if (!errors.dealData.dealValuationFilesData) {
        errors.dealData.dealValuationFilesData = {};
      }

      Object.keys(values.dealData.dealValuationFilesData).forEach((valueGroupIndex: string): void => {
        if (!errors.dealData.dealValuationFilesData[valueGroupIndex]) {
          errors.dealData.dealValuationFilesData[valueGroupIndex] = {
            files: {},
          };
        }

        if (values.dealData.dealValuationFilesData[valueGroupIndex]) {
          dealValuationFileGroupRequiredFields.forEach((field: string): void => {
            if (!values.dealData.dealValuationFilesData[valueGroupIndex][field]) {
              errors.dealData.dealValuationFilesData[valueGroupIndex][field] = 'Required';
            }
          });

          if (values.dealData.dealValuationFilesData[valueGroupIndex].files) {
            Object.keys(values.dealData.dealValuationFilesData[valueGroupIndex].files).forEach((
              valueIndex: string,
            ): void => {
              const dealValuationFileId: number = FormatService.parseInt(
                FormService.extractIndexedFormFieldKey(valueIndex) as string,
              );
              const dealValuationFileData: ValidationEntityInput = {
                ...values.dealData.dealValuationFilesData[valueGroupIndex].files[valueIndex],
              };

              if (!dealValuationFileData) {
                return;
              }

              if (!errors.dealData.dealValuationFilesData[valueGroupIndex].files[valueIndex]) {
                errors.dealData.dealValuationFilesData[valueGroupIndex].files[valueIndex] = {};
              }

              dealValuationFileRequiredFields.forEach((field: string): void => {
                if (!dealValuationFileData[field] || !dealValuationFileData[field].toString().trim()) {
                  errors.dealData.dealValuationFilesData[valueGroupIndex].files[valueIndex][field] = 'Required';
                }
              });

              if (!dealValuationFileData.id && !dealValuationFileData.file) {
                errors.dealData.dealValuationFilesData[valueGroupIndex].files[valueIndex].file = 'Required';
              }

              if (dealValuationFileData.group && Object.keys(dealValuationFileData.group).length) {
                if (!errors.dealData.dealValuationFilesData[valueGroupIndex].files[valueIndex].group) {
                  errors.dealData.dealValuationFilesData[valueGroupIndex].files[valueIndex].group = {};
                }

                dealValuationFileRequiredFields.forEach((field: string): void => {
                  if (!dealValuationFileData.group[field] || !dealValuationFileData.group[field].toString().trim()) {
                    errors.dealData.dealValuationFilesData[valueGroupIndex].files[valueIndex].group[field] = 'Required';
                  }
                });
              } else if (!dealValuationFileData.groupId || !dealValuationFileData.groupId.toString().trim()) {
                errors.dealData.dealValuationFilesData[valueGroupIndex].files[valueIndex].groupId = 'Required';
              }

              if (errors.dealData.dealValuationFilesData[valueGroupIndex].files[valueIndex] && (
                !Object.keys(errors.dealData.dealValuationFilesData[valueGroupIndex].files[valueIndex]).length
                || (dealValuationFileId < 0 && (dealValuationFileData.name === null
                  || dealValuationFileData.file === null))
              )) {
                delete errors.dealData.dealValuationFilesData[valueGroupIndex].files[valueIndex];
              }
            });
          }
        }

        if (errors.dealData.dealValuationFilesData[valueGroupIndex] && (
          !Object.keys(errors.dealData.dealValuationFilesData[valueGroupIndex]).length
          || !Object.keys(errors.dealData.dealValuationFilesData[valueGroupIndex].files).length
        )) {
          delete errors.dealData.dealValuationFilesData[valueGroupIndex];
        }
      });

      if (errors.dealData.dealValuationFilesData && !Object.keys(errors.dealData.dealValuationFilesData).length) {
        delete errors.dealData.dealValuationFilesData;
      }
    }

    if (values.dealData.dealTasksData) {
      if (!errors.dealData.dealTasksData) {
        errors.dealData.dealTasksData = {};
      }

      Object.keys(values.dealData.dealTasksData).forEach((valueGroupIndex: string): void => {
        if (values.dealData.dealTasksData[valueGroupIndex]) {
          if (!errors.dealData.dealTasksData[valueGroupIndex]) {
            errors.dealData.dealTasksData[valueGroupIndex] = {
              tasks: {},
            };
          }

          dealTaskGroupRequiredFields.forEach((field: string): void => {
            if ((!values.dealData.dealTasksData[valueGroupIndex][field]
              || !values.dealData.dealTasksData[valueGroupIndex][field].toString().trim())) {
              errors.dealData.dealTasksData[valueGroupIndex][field] = 'Required';
            }
          });

          if (values.dealData.dealTasksData[valueGroupIndex].tasks
            && Object.keys(values.dealData.dealTasksData[valueGroupIndex].tasks).length) {
            Object.keys(values.dealData.dealTasksData[valueGroupIndex].tasks).forEach((valueIndex: string): void => {
              const dealTaskId: number = FormatService.parseInt(
                FormService.extractIndexedFormFieldKey(valueIndex) as string,
              );
              const dealTaskData: ValidationEntityInput = {
                ...values.dealData.dealTasksData[valueGroupIndex].tasks[valueIndex],
              };

              if (!dealTaskData) {
                return;
              }

              if (!errors.dealData.dealTasksData[valueGroupIndex].tasks[valueIndex]) {
                errors.dealData.dealTasksData[valueGroupIndex].tasks[valueIndex] = {};
              }

              dealTaskRequiredFields.forEach((field: string): void => {
                if (!dealTaskData[field] || !dealTaskData[field].toString().trim()) {
                  errors.dealData.dealTasksData[valueGroupIndex].tasks[valueIndex][field] = 'Required';
                }
              });

              if (dealTaskData.contact) {
                if (!errors.dealData.dealTasksData[valueGroupIndex].tasks[valueIndex].contact) {
                  errors.dealData.dealTasksData[valueGroupIndex].tasks[valueIndex].contact = {};
                }

                contactPersonRequiredFields.forEach((field: string): void => {
                  if (!dealTaskData.contact[field] || !dealTaskData.contact[field].toString().trim()) {
                    errors.dealData.dealTasksData[valueGroupIndex].tasks[valueIndex].contact[field] = 'Required';
                  }
                });

                if (dealTaskData.contact.email && !FormatService.isValidEmail(dealTaskData.contact.email)) {
                  errors.dealData.dealTasksData[valueGroupIndex]
                    .tasks[valueIndex].contact.email = 'Invalid email address';
                }
              }

              if (dealTaskData.group && Object.keys(dealTaskData.group).length) {
                if (!errors.dealData.dealTasksData[valueGroupIndex].tasks[valueIndex].group) {
                  errors.dealData.dealTasksData[valueGroupIndex].tasks[valueIndex].group = {};
                }

                dealTaskGroupRequiredFields.forEach((field: string): void => {
                  if (!dealTaskData.group[field] || !dealTaskData.group[field].toString().trim()) {
                    errors.dealData.dealTasksData[valueGroupIndex].tasks[valueIndex].group[field] = 'Required';
                  }
                });

                if (errors.dealData.dealTasksData[valueGroupIndex].tasks[valueIndex].group
                  && !Object.keys(errors.dealData.dealTasksData[valueGroupIndex].tasks[valueIndex].group).length) {
                  delete errors.dealData.dealTasksData[valueGroupIndex].tasks[valueIndex].group;
                }
              } else if (!dealTaskData.groupId || !dealTaskData.groupId.toString().trim()) {
                errors.dealData.dealTasksData[valueGroupIndex].tasks[valueIndex].groupId = 'Required';
              }

              if (errors.dealData.dealTasksData[valueGroupIndex].tasks[valueIndex] && (
                !Object.keys(errors.dealData.dealTasksData[valueGroupIndex].tasks[valueIndex]).length
                || ((valueIndex === formKeyNew || dealTaskId < 0) && dealTaskData.name === null)
              )) {
                delete errors.dealData.dealTasksData[valueGroupIndex].tasks[valueIndex];
              }
            });
          }

          if (!Object.keys(errors.dealData.dealTasksData[valueGroupIndex].tasks).length) {
            delete errors.dealData.dealTasksData[valueGroupIndex].tasks;
          }

          if (errors.dealData.dealTasksData[valueGroupIndex] && (
            !Object.keys(errors.dealData.dealTasksData[valueGroupIndex]).length
            || (valueGroupIndex === formKeyNew && values.dealData.dealTasksData[valueGroupIndex].name === null
              && (!errors.dealData.dealTasksData[valueGroupIndex].tasks
                || !Object.keys(errors.dealData.dealTasksData[valueGroupIndex].tasks).length))
          )) {
            delete errors.dealData.dealTasksData[valueGroupIndex];
          }
        }
      });

      if (errors.dealData.dealTasksData && !Object.keys(errors.dealData.dealTasksData).length) {
        delete errors.dealData.dealTasksData;
      }
    }

    if (values.dealData.dealParticipantsData) {
      if (!errors.dealData.dealParticipantsData) {
        errors.dealData.dealParticipantsData = {};
      }

      Object.keys(values.dealData.dealParticipantsData).forEach((valueIndex: string): void => {
        const dealParticipantData: ValidationEntityInput = {
          ...values.dealData.dealParticipantsData[valueIndex],
        };

        if (!dealParticipantData) {
          return;
        }

        if (!errors.dealData.dealParticipantsData[valueIndex]) {
          errors.dealData.dealParticipantsData[valueIndex] = {};
        }

        dealParticipantRequiredFields.forEach((field: string): void => {
          if (!dealParticipantData[field] || !dealParticipantData[field].toString().trim()) {
            errors.dealData.dealParticipantsData[valueIndex][field] = 'Required';
          }
        });

        if (dealParticipantData.user) {
          if (!errors.dealData.dealParticipantsData[valueIndex].user) {
            errors.dealData.dealParticipantsData[valueIndex].user = {};
          }

          dealParticipantUserRequiredFields.forEach((field: string): void => {
            if (!dealParticipantData.user[field] || !dealParticipantData.user[field].toString().trim()) {
              errors.dealData.dealParticipantsData[valueIndex].user[field] = 'Required';
            }
          });

          if (dealParticipantData.user.email && !FormatService.isValidEmail(dealParticipantData.user.email)) {
            errors.dealData.dealParticipantsData[valueIndex].user.email = 'Invalid email address';
          }

          if (dealParticipantData.user.phone && !FormatService.isValidPhoneNumber(dealParticipantData.user.phone)) {
            errors.dealData.dealParticipantsData[valueIndex].user.phone = 'Invalid phone number';
          }

          const isAccessLevelView: boolean = dealParticipantData.user.accountUserTypeGroup
            && dealParticipantData.user.accountUserTypeGroup === ACCOUNT_USER_TYPE_GROUP_EXTERNAL;
          if (isAccessLevelView && !dealParticipantData.accessLevel) {
            errors.dealData.dealParticipantsData[valueIndex].accessLevel = 'Required';
          }

          if (!dealParticipantData.user.withSendInvitation) {
            if (dealParticipantData.user.password && !dealParticipantData.user.passwordConfirm) {
              errors.dealData.dealParticipantsData[valueIndex].user.passwordConfirm = 'Required';
            }

            if (dealParticipantData.user.passwordConfirm && !dealParticipantData.user.password) {
              errors.dealData.dealParticipantsData[valueIndex].user.password = 'Required';
            }

            if (dealParticipantData.user.password
              && !FormatService.isValidPassword(dealParticipantData.user.password)) {
              errors.dealData.dealParticipantsData[valueIndex]
                .user.password = `Password must contain ${FormService.PASSWORD_FIELD_LENGTH_MIN} characters, `
                + 'at least one letter in lower case, one letter in upper case and one number or one symbol';
            }

            if (dealParticipantData.user.password && dealParticipantData.user.passwordConfirm
              && dealParticipantData.user.password !== dealParticipantData.user.passwordConfirm) {
              errors.dealData.dealParticipantsData[valueIndex]
                .user.passwordConfirm = 'Password confirmation does not match';
            }
          }
        }

        if (errors.dealData.dealParticipantsData[valueIndex] && (
          !Object.keys(errors.dealData.dealParticipantsData[valueIndex]).length
          || (valueIndex === formKeyNew && dealParticipantData.groupId === undefined)
        )) {
          delete errors.dealData.dealParticipantsData[valueIndex];
        }
      });

      if (errors.dealData.dealParticipantsData && !Object.keys(errors.dealData.dealParticipantsData).length) {
        delete errors.dealData.dealParticipantsData;
      }
    }

    if (values.dealData.dealFilesData) {
      if (!errors.dealData.dealFilesData) {
        errors.dealData.dealFilesData = {};
      }

      Object.keys(values.dealData.dealFilesData).forEach((valueGroupIndex: string): void => {
        if (!errors.dealData.dealFilesData[valueGroupIndex]) {
          errors.dealData.dealFilesData[valueGroupIndex] = {
            files: {},
          };
        }

        if (values.dealData.dealFilesData[valueGroupIndex]) {
          dealFileGroupRequiredFields.forEach((field: string): void => {
            if ((!values.dealData.dealFilesData[valueGroupIndex][field]
              || !values.dealData.dealFilesData[valueGroupIndex][field].toString().trim())) {
              errors.dealData.dealFilesData[valueGroupIndex][field] = 'Required';
            }
          });

          if (values.dealData.dealFilesData[valueGroupIndex].files
            && Object.keys(values.dealData.dealFilesData[valueGroupIndex].files).length) {
            Object.keys(values.dealData.dealFilesData[valueGroupIndex].files).forEach((valueIndex: string): void => {
              const dealFileId: number = FormatService.parseInt(
                FormService.extractIndexedFormFieldKey(valueIndex) as string,
              );

              const dealFileData: ValidationEntityInput = {
                ...values.dealData.dealFilesData[valueGroupIndex].files[valueIndex],
              };

              if (!dealFileData) {
                return;
              }

              if (!errors.dealData.dealFilesData[valueGroupIndex].files[valueIndex]) {
                errors.dealData.dealFilesData[valueGroupIndex].files[valueIndex] = {};
              }

              dealFileRequiredFields.forEach((field: string): void => {
                if (!dealFileData[field] || !dealFileData[field].toString().trim()) {
                  errors.dealData.dealFilesData[valueGroupIndex].files[valueIndex][field] = 'Required';
                }
              });

              if (!dealFileData.id && !dealFileData.file) {
                errors.dealData.dealFilesData[valueGroupIndex].files[valueIndex].file = 'Required';
              }

              if (dealFileData.group && Object.keys(dealFileData.group).length) {
                if (errors.dealData.dealFilesData[valueGroupIndex].files[valueIndex].group) {
                  errors.dealData.dealFilesData[valueGroupIndex].files[valueIndex].group = {};
                }

                dealFileGroupRequiredFields.forEach((field: string): void => {
                  if (!dealFileData.group[field] || !dealFileData.group[field].toString().trim()) {
                    errors.dealData.dealFilesData[valueGroupIndex].files[valueIndex].group[field] = 'Required';
                  }
                });

                if (errors.dealData.dealFilesData[valueGroupIndex].files[valueIndex].group
                  && !Object.keys(errors.dealData.dealFilesData[valueGroupIndex].files[valueIndex].group).length) {
                  delete errors.dealData.dealFilesData[valueGroupIndex].files[valueIndex].group;
                }
              } else if (!dealFileData.groupId || !dealFileData.groupId.toString().trim()) {
                errors.dealData.dealFilesData[valueGroupIndex].files[valueIndex].groupId = 'Required';
              }

              if (errors.dealData.dealFilesData[valueGroupIndex].files[valueIndex] && (
                !Object.keys(errors.dealData.dealFilesData[valueGroupIndex].files[valueIndex]).length
                || ((valueIndex === formKeyNew || dealFileId < 0) && (dealFileData.name === null
                  || dealFileData.file === null))
              )) {
                delete errors.dealData.dealFilesData[valueGroupIndex].files[valueIndex];
              }
            });
          }
        }

        if (!Object.keys(errors.dealData.dealFilesData[valueGroupIndex].files).length) {
          delete errors.dealData.dealFilesData[valueGroupIndex].files;
        }

        if (errors.dealData.dealFilesData[valueGroupIndex] && (
          !Object.keys(errors.dealData.dealFilesData[valueGroupIndex]).length
          || (valueGroupIndex === formKeyNew && values.dealData.dealFilesData[valueGroupIndex].name === null
            && (!errors.dealData.dealFilesData[valueGroupIndex].files
              || !Object.keys(errors.dealData.dealFilesData[valueGroupIndex].files).length))
        )) {
          delete errors.dealData.dealFilesData[valueGroupIndex];
        }
      });

      if (errors.dealData.dealFilesData && !Object.keys(errors.dealData.dealFilesData).length) {
        delete errors.dealData.dealFilesData;
      }
    }

    if (values.dealData.dealSchedulesData) {
      if (!errors.dealData.dealSchedulesData) {
        errors.dealData.dealSchedulesData = {};
      }

      Object.keys(values.dealData.dealSchedulesData).forEach((groupIndex: string): void => {
        const dealScheduleData: ValidationEntityInput = {
          ...values.dealData.dealSchedulesData[groupIndex],
        };

        if (!dealScheduleData) {
          return;
        }

        if (!errors.dealData.dealSchedulesData[dealScheduleData.id]) {
          errors.dealData.dealSchedulesData[dealScheduleData.id] = {};
        }

        dealScheduleRequiredFields.forEach((field: string): void => {
          if (!dealScheduleData[field] || !dealScheduleData[field].toString().trim()) {
            errors.dealData.dealSchedulesData[dealScheduleData.id][field] = 'Required';
          }
        });

        if (dealScheduleData.tasks && Object.keys(dealScheduleData.tasks).length) {
          if (!errors.dealData.dealSchedulesData[dealScheduleData.id].tasks) {
            errors.dealData.dealSchedulesData[dealScheduleData.id].tasks = {};
          }

          Object.keys(dealScheduleData.tasks).forEach((valueIndex: string): void => {
            const dealScheduleTaskData: ValidationEntityInput = {
              ...dealScheduleData.tasks[valueIndex],
            };

            if (!dealScheduleTaskData) {
              return;
            }

            if (!errors.dealData.dealSchedulesData[dealScheduleData.id].tasks[valueIndex]) {
              errors.dealData.dealSchedulesData[dealScheduleData.id].tasks[valueIndex] = {};
            }

            dealScheduleTaskRequiredFields.forEach((field: string): void => {
              if (!dealScheduleTaskData[field] || !dealScheduleTaskData[field].toString().trim()) {
                errors.dealData.dealSchedulesData[dealScheduleData.id].tasks[valueIndex][field] = 'Required';
              }
            });

            if (errors.dealData.dealSchedulesData[dealScheduleData.id].tasks[valueIndex]
              && !Object.keys(errors.dealData.dealSchedulesData[dealScheduleData.id].tasks[valueIndex]).length) {
              delete errors.dealData.dealSchedulesData[dealScheduleData.id].tasks[valueIndex];
            }
          });

          if (errors.dealData.dealSchedulesData[dealScheduleData.id].tasks
            && !Object.keys(errors.dealData.dealSchedulesData[dealScheduleData.id].tasks).length) {
            delete errors.dealData.dealSchedulesData[dealScheduleData.id].tasks;
          }
        }

        if (dealScheduleData.links && Object.keys(dealScheduleData.links).length) {
          if (!errors.dealData.dealSchedulesData[dealScheduleData.id].links) {
            errors.dealData.dealSchedulesData[dealScheduleData.id].links = {};
          }

          Object.keys(dealScheduleData.links).forEach((valueIndex: string): void => {
            const dealScheduleTaskLinkData: ValidationEntityInput = {
              ...dealScheduleData.links[valueIndex],
            };

            if (!dealScheduleTaskLinkData) {
              return;
            }

            if (!errors.dealData.dealSchedulesData[dealScheduleData.id].links[valueIndex]) {
              errors.dealData.dealSchedulesData[dealScheduleData.id].links[valueIndex] = {};
            }

            dealScheduleTaskLinkRequiredFields.forEach((field: string): void => {
              if (!dealScheduleTaskLinkData[field] || !dealScheduleTaskLinkData[field].toString().trim()) {
                errors.dealData.dealSchedulesData[dealScheduleData.id].links[valueIndex][field] = 'Required';
              }
            });

            if (errors.dealData.dealSchedulesData[dealScheduleData.id].links[valueIndex]
              && !Object.keys(errors.dealData.dealSchedulesData[dealScheduleData.id].links[valueIndex]).length) {
              delete errors.dealData.dealSchedulesData[dealScheduleData.id].links[valueIndex];
            }
          });

          if (errors.dealData.dealSchedulesData[dealScheduleData.id].links
            && !Object.keys(errors.dealData.dealSchedulesData[dealScheduleData.id].links).length) {
            delete errors.dealData.dealSchedulesData[dealScheduleData.id].links;
          }
        }

        if (errors.dealData.dealSchedulesData[dealScheduleData.id] && (
          !Object.keys(errors.dealData.dealSchedulesData[dealScheduleData.id]).length
          || (groupIndex === formKeyNew && dealScheduleData.name === null)
        )) {
          delete errors.dealData.dealSchedulesData[dealScheduleData.id];
        }
      });

      if (errors.dealData.dealSchedulesData && !Object.keys(errors.dealData.dealSchedulesData).length) {
        delete errors.dealData.dealSchedulesData;
      }
    }

    if (values.dealData.activityListData) {
      const activityListErrors: ValidationErrors = ActivityListValidator({
        activityListData: values.dealData.activityListData,
      });

      errors.dealData.activityListData = (activityListErrors && activityListErrors.activityListData) || {};

      if (errors.dealData.activityListData[formKeyNew] && errors.dealData.activityListData[formKeyNew].dealId) {
        delete errors.dealData.activityListData[formKeyNew].dealId;
      }

      if (errors.dealData.activityListData[formKeyNew]
        && !Object.keys(errors.dealData.activityListData[formKeyNew]).length) {
        delete errors.dealData.activityListData[formKeyNew];
      }

      if (errors.dealData.activityListData && !Object.keys(errors.dealData.activityListData).length) {
        delete errors.dealData.activityListData;
      }
    }
  }

  if (errors.dealData && !Object.keys(errors.dealData).length) {
    delete errors.dealData;
  }

  return errors;
};

export default DealValidator;
